module.exports = __webpack_public_path__ + "static/media/dots-top-right.3bdbc32a.png";